import { render, staticRenderFns } from "./BoardHeader.vue?vue&type=template&id=9e0f9396&"
import script from "./BoardHeader.vue?vue&type=script&lang=ts&"
export * from "./BoardHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BoardHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VProgressLinear,VSpacer,VTooltip})
